import { render, staticRenderFns } from "./PenaltyChargeNotice.vue?vue&type=template&id=3f3c413d&scoped=true&"
import script from "./PenaltyChargeNotice.vue?vue&type=script&lang=js&"
export * from "./PenaltyChargeNotice.vue?vue&type=script&lang=js&"
import style0 from "./PenaltyChargeNotice.vue?vue&type=style&index=0&id=3f3c413d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c413d",
  null
  
)

export default component.exports